export default {
  meta: {
    title: '商圈范围',
    url: '/insight/map', // 埋点字段，上报归属的模块
    urlName: '周边查询' // 埋点字段，上报归属的模块
  }
};
